module.exports = __webpack_public_path__ + "static/media/home-content.2f175760.png";